<template>
    <div class="sidebar-overlay" :class="{ 'show': sideBarState }" @click="changeSideBarState"></div>
    <div class="weeduc-sidebar sidebar primary" :class="{ 'show': sideBarState }">
        <fa v-if="sideBarState && isMobile" icon="fa-times" class="icon-close" @click="changeSideBarState"/>
        <div class="sidebar-header">
            <div class="header-logo">
                <!-- Exibe o ícone mobile apenas quando está no mobile E a sidebar está fechada -->
                <div class="logo"  v-if="isMobile && !sideBarState"  @click="$router.push('/dashboard/painel')">
                    <img class="logo_black" src="./../../assets/weeduc-icone.svg" style="width: 100%;">
                    <img class="logo_white" src="./../../assets/weeduc-icone.svg" style="width: 100%;">
                </div>
                <!-- Exibe o ícone desktop quando NÃO está no mobile OU quando está no mobile com sidebar aberta -->
                <div class="logo" v-else @click="$router.push('/dashboard/painel')">
                    <img class="logo_black" src="./../../assets/logo_white.png" style="width: 100%;">
                    <img class="logo_white" src="./../../assets/logo_white.png" style="width: 100%;">
                </div>
            </div>
        </div>
        <div class="sidebar-content">
            <div class="content-link">
                <div class="link" v-for="(itens, index) in dataSidebar" :key="index">
                    <router-link class="link-content primary" :to="itens.link" :class="{ active: activeIndex == index }"
                        @click="setActiveIndex(index)">
                        <span class="link-icon">
                            <fa :icon="itens.icon" style="font-size: 1rem"/>
                        </span>
                        <span class="link-text">
                            <span class="text">
                               {{ itens.name }}
                            </span>
                        </span>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="version">
            <span class="version-text desktop">
                Versão: {{ versionPortalWeeduc || 'Desconhecida' }}
            </span>
            <span class="version-text mobile">
                Versão: {{ versionPortalWeeduc || 'Versão Desconhecida' }}
            </span>
        </div>
    </div>
</template>

<script>
import store from '@/store';
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            menu: [],
            activeIndex: null,
            secondoactiveindex: null,
            lenguage: "pt",
            label_lenguage: "Idioma",
            typeUser: '',
            windowWidth: window.innerWidth,
            typesReports: ['Dúvidas', 'Fóruns', 'Avisos', 'Usuários', 'Vendas', 'Cursos'],
            iconsReports: ['fa-question-circle', 'fa-bookmark', 'fa-bell', 'fa-user', 'fa-money-bill', 'fa-chart-line'],
            linksReports: ['duvidas', 'foruns', 'avisos', 'usuarios', 'vendas', 'cursos'],
            dataSidebar: [
                {
                    name: 'Painel',
                    link: '/dashboard/painel',
                    icon: 'fa-square-poll-vertical',
                    type: '0'
                },
                {
                    name: 'Cursos',
                    link: '/dashboard/cursos',
                    icon: 'fa-book',
                    type: '0'
                },
                {
                    name: 'Dúvidas',
                    link: '/dashboard/duvidas',
                    icon: 'fa-circle-question',
                    type: '0'
                },
                {
                    name: 'Fórum',
                    link: '/dashboard/forum',
                    icon: 'fa-users',
                    type: '0'
                },
                {
                    name: 'Avisos',
                    link: '/dashboard/avisos',
                    icon: 'fa-bell',
                    type: '0'
                },
                {
                    name: 'Certificados',
                    link: '/dashboard/certificados',
                    icon: 'fa-certificate',
                    type: '1'
                },
                {
                    name: 'Usuários',
                    link: '/dashboard/usuarios',
                    icon: 'fa-user-group',
                    type: '1'
                },
                {
                    name: 'Relatórios',
                    link: '/dashboard/relatorios',
                    icon: 'fa-file-lines',
                    type: '1'
                },
                {
                    name: 'Cupons',
                    link: '/dashboard/cupons',
                    icon: 'fa-ticket',
                    type: '1'
                },
                {
                    name: 'Site',
                    link: '/dashboard/site',
                    icon: 'fa-earth-americas',
                    type: '1'
                }
            ],
            versionPortalWeeduc: '',
        }
    },
    computed: {
        ...mapState(['sideBarState']),
        isMobile() {
            return this.windowWidth <= 768;
        }
    },
    methods: {
        ...mapActions(['storeTypeId', 'storeSideBarState']),

        changeType() {
            this.storeTypeId({ typeId: this.typeUser })
        },
        setActiveIndex(index) {
            if (this.activeIndex === index) {
                // this.activeIndex = null;
            } else {
                if (this.setActiveIndex != 8) {
                    this.secondoactiveindex = null;
                }
                this.activeIndex = index;
            }
            localStorage.setItem('activeIndex', this.activeIndex);
        },
        setSecondIndex(index) {
            if (this.secondoactiveindex === index) {

            } else {
                this.secondoactiveindex = index;
            }
            localStorage.setItem('activeSecondIndex', this.secondoactiveindex);
            localStorage.setItem('activeIndex', this.activeIndex);
        },
        changeLenguage() {
            this.menu = require('../../locale/pt/sidebar.json');
            localStorage.setItem('lenguage', this.lenguage);
            const lenguage = localStorage.getItem('lenguage');
            this.lenguage = lenguage;
        },
        tranformtext(index) {
            if (index == "pt") {
                return 'Português';
            } else if (index == "en") {
                return 'English'
            } else if (index == "es") {
                return 'Español'
            }
        },
        changeSideBarState() {
            this.storeSideBarState({ sideBarState: !this.sideBarState })
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
            if (window.innerWidth > 768 && this.sideBarState) {
                return;
            }
        },
    },
    created() {
        this.typeUser = store.state.typeId;
        const savedActiveIndex = localStorage.getItem('activeIndex');
        const savedSecondoActiveIndex = localStorage.getItem('activeSecondIndex');
        
        if (savedActiveIndex !== null) {
            this.activeIndex = parseInt(savedActiveIndex, 10);
        }
        if (savedSecondoActiveIndex !== null) {
            this.secondoactiveindex = parseInt(savedSecondoActiveIndex, 10);
        }

        const lenguage = localStorage.getItem('lenguage');

        if (lenguage == null) {
            this.menu = require('../../locale/pt/sidebar.json');
        } else {
            this.menu = require('../../locale/pt/sidebar.json');
        }

        this.versionPortalWeeduc = process.env.VUE_APP_VERSION_PORTAL_WEEDUC;
        console.log('versao',this.versionPortalWeeduc);
    },
    
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>

<style scoped>
@import './sidebar.css';
@media screen and (max-width: 768px) {
    .version-text.desktop {
        display: none;
    }
    .version-text.mobile {
        display: block;
    }
    .version {
        position: absolute;
        bottom: 5px;
        left: 4px;
    }
}
@media screen and (min-width: 768px) {
    .version-text.desktop {
        display: block;
    }
    .version-text.mobile {
        display: none;
    }
}

</style>